import PosPage from './views/PosPage.vue';

const routes = [
  {
    path: '/pos',
    component: PosPage,
    name: 'pos',
    props: (route) => ({ ...route.query, ...route.params }),
    meta: { i18n: ['point-of-sale-pov', 'datetime-pov'], pageNameEn: 'Point of Sale' },
  },
  {
    path: '/embedded/vcitapay/reports',
    name: 'paymentReports',
    component: () => import(/* webpackChunkName: "PaymentReportsPage" */ './views/PaymentReportsPage.vue'),
    meta: { i18n: 'payments-pov', pageNameEn: 'Transactions & Payouts' },
  },
];

export default routes;
